import { render, staticRenderFns } from "./GameCenter.vue?vue&type=template&id=03c80a06&scoped=true&"
import script from "./GameCenter.vue?vue&type=script&lang=js&"
export * from "./GameCenter.vue?vue&type=script&lang=js&"
import style0 from "./GameCenter.vue?vue&type=style&index=0&id=03c80a06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c80a06",
  null
  
)

export default component.exports